import React from 'react'

export default function Terr() {
  return (
    <div>
      Terr
    </div>
  )
}
